import { useMemo } from 'react'

import {
  WorkspacesSelectorDocument,
  type WorkspacesSelectorQuery,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export interface LocationOption {
  label: string
  value: number
}

export const useLocations = (): {
  locations: LocationOption[]
  loading: boolean
  error?: unknown
} => {
  const { data, loading, error } = useQuery<WorkspacesSelectorQuery, Record<string, never>>(
    WorkspacesSelectorDocument,
    {
      fetchPolicy: 'cache-and-network',
    }
  )

  const nodes = useMemo<
    NonNullable<WorkspacesSelectorQuery['spaceControl']>['workSpacesConnection']['nodes']
  >(
    () => data?.spaceControl?.workSpacesConnection?.nodes ?? [],
    [data?.spaceControl?.workSpacesConnection?.nodes]
  )

  const locations = useMemo<LocationOption[]>(() => {
    return nodes
      .filter((node): node is NonNullable<(typeof nodes)[number]> => Boolean(node))
      .map((node) => ({
        label: node.name ?? '',
        value: Number(node.id),
      }))
  }, [nodes])

  return { locations, loading, error }
}
